var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5161,
    cy: 17.4516,
    r: 15.4839,
    fill: "#73C7A9",
    stroke: "white",
    strokeWidth: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7524 11.2581L23.7095 13.2152L22.2175 14.7078L20.2605 12.7507L21.7524 11.2581ZM14.5842 20.3833H16.5413L21.2951 15.6296L19.338 13.6725L14.5842 18.4262V20.3833Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7603 22.3404H14.6874C14.6704 22.3404 14.6528 22.3469 14.6359 22.3469C14.6143 22.3469 14.5928 22.3411 14.5706 22.3404H12.6272V13.2073H17.094L18.3987 11.9026H12.6272C11.9077 11.9026 11.3225 12.4871 11.3225 13.2073V22.3404C11.3225 23.0606 11.9077 23.6451 12.6272 23.6451H21.7603C22.1064 23.6451 22.4382 23.5077 22.6829 23.263C22.9276 23.0183 23.0651 22.6865 23.0651 22.3404V16.6857L21.7603 17.9905V22.3404Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBadge);
export default __webpack_public_path__ + "static/media/edit_badge.d727213239553ac156736c3215d61d26.svg";
export { ForwardRef as ReactComponent };